import cloneDeep from 'lodash/cloneDeep';
import { freezeSys, toPlainObject } from 'contentful-sdk-core';
import enhanceWithMethods from '../enhance-with-methods';
import { createUpdateEntity, createDeleteEntity } from '../instance-actions';
import { wrapCollection } from '../common-utils';
var entityPath = 'app_definitions';

function createAppDefinitionApi(http) {
  return {
    update: createUpdateEntity({
      http: http,
      entityPath: entityPath,
      wrapperMethod: wrapAppDefinition
    }),
    "delete": createDeleteEntity({
      http: http,
      entityPath: entityPath
    })
  };
}
/**
 * @private
 * @param http - HTTP client instance
 * @param data - Raw App Definition data
 * @return Wrapped App Definition data
 */


export function wrapAppDefinition(http, data) {
  var appDefinition = toPlainObject(cloneDeep(data));
  var appDefinitionWithMethods = enhanceWithMethods(appDefinition, createAppDefinitionApi(http));
  return freezeSys(appDefinitionWithMethods);
}
/**
 * @private
 * @param http - HTTP client instance
 * @param data - Raw App Definition collection data
 * @return Wrapped App Definition collection data
 */

export var wrapAppDefinitionCollection = wrapCollection(wrapAppDefinition);